import Service from "../AuthService"

const footer = {
  getFooter () {
    return Service.get(`/api/footer`)
  },
  updateFooter (data) {
    return Service.put(`/api/footer`, data)
  }
}

export default footer
